export default {"src":"/_next/static/media/dimension-tooltip.930908e2.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};